export default __webpack_public_path__ + "static/media/barrel.2ed0ca73.jpg";